<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>
    <ion-title> {{ 'Detalhes de inscrição' | translate }} </ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-row class="ion-justify-content-center">
          <ion-col size="6" class="alinhamento-center">
            <img [src]="pessoa?.foto | image:''" class="image" />
          </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-center">
          <ion-col size="10">
            <h2 class="nome-pessoa">{{pessoa.nome}}</h2>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <div class="ion-margin-horizontal">
      <ion-row>
        <ion-col>
          <h1 class="title">{{'Dados de contato' | translate}}</h1>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="1.5" class="ion-align-self-center">
          <i class="fa-regular fa-envelope"></i>
        </ion-col>
        <ion-col size="10.5" class="ion-align-self-center" (click)=" abrirEmail(pessoa.contato.email)">
          <p class="nome-info">{{'Email' | translate}}</p>
          <span>{{(pessoa.contato.email) || ('Não informado' | translate)}}</span>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="1.5" class="ion-align-self-center">
          <i class="fa-regular fa-phone"></i>
        </ion-col>
        <ion-col size="10.5" (click)="abrirContato(pessoa.contato.telCelular)">
          <p class="nome-info">{{'Telefone' | translate}}</p>
          <p>{{(pessoa.contato.telCelular) || ('Não informado' | translate)}}</p>
        </ion-col>
      </ion-row>
    </div>

    <ion-item-divider></ion-item-divider>

    <ion-row class="ion-margin-horizontal" *ngIf="questionario.hasQuestionario">
      <ion-col size="12">
        <h1 class="title">{{'Respostas do questionário' | translate}}</h1>
      </ion-col>
    </ion-row>

    <ng-container *ngIf="questionario.hasQuestionario">
      <ion-row *ngFor="let pergunta of questionario.perguntas" class="box-resp ion-margin">
        <ion-col size="12">
          <p class="pergunta">{{pergunta.pergunta}}</p>

          <ng-container *ngIf="pergunta.tipo == '3'">
            <p class="respotas ion-margin-top">{{ (pergunta.resposta) || ('Não informado' | translate) }}</p>
          </ng-container>

          <ng-container *ngIf="pergunta.tipo != '3'">
            <ng-container *ngIf="pergunta.resposta?.length > 0; else naoRespondido">
              <ng-container *ngFor="let alt of pergunta.alternativas">
                <p *ngIf="pergunta.resposta.includes(alt.id)" class="respostas ion-margin-top">{{ alt.alternativa }}</p>
              </ng-container>
            </ng-container>

            <ng-template #naoRespondido>
              <p class="respostas ion-margin-top">{{ 'Não informado' | translate }}</p>
            </ng-template>
          </ng-container>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>
</ion-content>
